const description = {
    email: 'email',
    phone_number: 'număr de telefon',
    username: 'nume de utilizator',
    reminder: 'Memento',
    not_found: '404 Nepreluat',
    agree_with_terms: 'Am citit și sunt de acord cu ',
    agree_with_terms_modal: 'Pentru a continua, vă rugăm să fiți de acord cu <link></link>.',
    terms_of_use: 'Termeni de utilizare',
    sign_in: 'Autentificare',
    privacy_policy: 'Politica de confidențialitate',
    create_account: 'Creează cont',
    or: 'sau',
    and: 'și',
    enter_passcode: 'Codul de verificare a fost trimis la {{address}} {{target}}',
    passcode_sent: 'Codul de verificare a fost retrimis',
    resend_after_seconds: 'Nu ați primit încă? Retrimiteți după <span>{{seconds}}</span> secunde',
    resend_passcode: 'Nu ați primit încă? <a>Retrimiteți codul de verificare</a>',
    create_account_id_exists: 'Un cont cu {{type}} {{value}} există deja, doriți să vă autentificați?',
    link_account_id_exists: 'Un cont cu {{type}} {{value}} există deja. Doriți să-l asociați?',
    sign_in_id_does_not_exist: 'Un cont cu {{type}} {{value}} nu există, doriți să creați un cont nou?',
    sign_in_id_does_not_exist_alert: 'Un cont cu {{type}} {{value}} nu există.',
    create_account_id_exists_alert: 'Contul cu {{type}} {{value}} este asociat cu un alt cont. Vă rugăm să încercați alt {{type}}.',
    social_identity_exist: '{{type}} {{value}} este asociat cu un alt cont. Vă rugăm să încercați alt {{type}}.',
    bind_account_title: 'Asociați sau creați un cont',
    social_create_account: 'Puteți crea un cont nou.',
    social_link_email: 'Puteți asocia un alt email',
    social_link_phone: 'Puteți asocia un alt număr de telefon',
    social_link_email_or_phone: 'Puteți asocia un alt email sau număr de telefon',
    social_bind_with_existing: 'Am găsit un cont asociat deja înregistrat, îl puteți lega direct.',
    skip_social_linking: 'Săriți peste asocierea cu un cont existent?',
    reset_password: 'Resetați parola',
    reset_password_description: 'Introduceți {{types, list(type: disjunction;)}} asociat contului dvs., și vă vom trimite codul de verificare pentru a reseta parola.',
    new_password: 'Parolă nouă',
    set_password: 'Setați parola',
    password_changed: 'Parola a fost schimbată',
    no_account: 'Nu aveți cont încă? ',
    have_account: 'Aveți deja un cont?',
    enter_password: 'Introduceți parola',
    enter_password_for: 'Autentificați-vă cu parola pentru {{method}} {{value}}',
    enter_username: 'Setați numele de utilizator',
    enter_username_description: 'Numele de utilizator este o alternativă pentru autentificare. Acesta trebuie să conțină doar litere, cifre și underscore (_).',
    link_email: 'Asociați email',
    link_phone: 'Asociați număr de telefon',
    link_email_or_phone: 'Asociați email sau număr de telefon',
    link_email_description: 'Pentru o securitate sporită, vă rugăm să asociați email-ul la cont.',
    link_phone_description: 'Pentru o securitate sporită, vă rugăm să asociați numărul de telefon la cont.',
    link_email_or_phone_description: 'Pentru o securitate sporită, vă rugăm să asociați email-ul sau numărul de telefon la cont.',
    continue_with_more_information: 'Pentru securitate suplimentară, completați detaliile contului de mai jos.',
    create_your_account: 'Creează-ți contul',
    sign_in_to_your_account: 'Autentifică-te în contul tău',
    no_region_code_found: 'Nu a fost găsit niciun cod de regiune',
    verify_email: 'Verificați email-ul',
    verify_phone: 'Verificați numărul de telefon',
    password_requirements: 'Parola {{items, list}}.',
    password_requirement: {
        length_one: 'necesită minimum {{count}} caracter',
        length_few: 'necesită minimum {{count}} caractere',
        length_other: 'necesită minimum {{count}} caractere',
        character_types_one: 'trebuie să conțină cel puțin {{count}} tip de litere mari, litere mici, cifre și simboluri',
        character_types_few: 'trebuie să conțină cel puțin {{count}} tipuri de litere mari, litere mici, cifre și simboluri',
        character_types_other: 'trebuie să conțină cel puțin {{count}} tipuri de litere mari, litere mici, cifre și simboluri',
    },
    use: 'Utilizați',
    single_sign_on_email_form: 'Introduceți adresa de email a companiei',
    single_sign_on_connectors_list: 'Compania dvs. a activat autentificarea unică (SSO) pentru contul de email {{email}}. Puteți continua autentificarea cu următorii furnizori SSO.',
    single_sign_on_enabled: 'Autentificarea unică (SSO) este activată pentru acest cont',
    authorize_title: 'Autorizați {{name}}',
    request_permission: '{{name}} solicită acces la:',
    grant_organization_access: 'Oferiți acces organizației:',
    authorize_personal_data_usage: 'Autorizați utilizarea datelor dvs. personale:',
    authorize_organization_access: 'Autorizați accesul la organizația specifică:',
    user_scopes: 'Date personale utilizator',
    organization_scopes: 'Acces organizație',
    authorize_agreement: `Prin autorizarea accesului, sunteți de acord cu <link></link> al {{name}}.`,
    authorize_agreement_with_redirect: `Prin autorizarea accesului, sunteți de acord cu <link></link> al {{name}}, și veți fi redirecționat către {{uri}}.`,
    not_you: 'Nu sunteți dvs.?',
    user_id: 'ID utilizator: {{id}}',
    redirect_to: 'Veți fi redirecționat către {{name}}.',
    auto_agreement: 'Continuând, sunteți de acord cu <link></link>.',
    identifier_sign_in_description: 'Introduceți {{types, list(type: disjunction;)}} pentru a vă autentifica.',
    all_sign_in_options: 'Toate opțiunile de autentificare',
    identifier_register_description: 'Introduceți {{types, list(type: disjunction;)}} pentru a crea un cont nou.',
    all_account_creation_options: 'Toate opțiunile de creare a contului',
    back_to_sign_in: 'Înapoi la autentificare',
    support_email: 'Email suport: <link></link>',
    support_website: 'Website suport: <link></link>',
};
export default Object.freeze(description);
